import trees from "./trees";

export default {
  namespaced: true,

  modules: {
    trees,
  },
};
